export const USER_LOGIN_REQUESTED = "USER_LOGIN_REQUESTED"
export const USER_LOGIN_SUCCESSFUL = "USER_LOGIN_SUCCESSFUL"
export const USER_LOGIN_FAILED = "USER_LOGIN_FAILED"
export const USER_REGISTRATION_REQUESTED = "USER_REGISTRATION_REQUESTED"
export const USER_REGISTRATION_SUCCESSFUL = "USER_REGISTRATION_SUCCESSFUL"
export const USER_REGISTRATION_FAILED = "USER_REGISTRATION_FAILED"
export const USER_FORGOT_PASSWORD_REQUESTED = "USER_FORGOT_PASSWORD_REQUESTED"
export const USER_FORGOT_PASSWORD_SUCCESSFUL = "USER_FORGOT_PASSWORD_SUCCESSFUL"
export const USER_FORGOT_PASSWORD_FAILED = "USER_FORGOT_PASSWORD_FAILED"
export const USER_RESET_PASSWORD_REQUESTED = "USER_RESET_PASSWORD_REQUESTED"
export const USER_RESET_PASSWORD_SUCCESSFUL = "USER_RESET_PASSWORD_SUCCESSFUL"
export const USER_RESET_PASSWORD_FAILED = "USER_RESET_PASSWORD_FAILED"
export const USER_RESEND_EMAIL_REQUESTED = "USER_RESEND_EMAIL_REQUESTED"
export const USER_RESEND_EMAIL_SUCCESSFUL = "USER_RESEND_EMAIL_SUCCESSFUL"
export const USER_RESEND_EMAIL_FAILED = "USER_RESEND_EMAIL_FAILED"
export const USER_CHANGE_PASSWORD_REQUESTED = "USER_CHANGE_PASSWORD_REQUESTED"
export const USER_CHANGE_PASSWORD_SUCCESSFUL = "USER_CHANGE_PASSWORD_SUCCESSFUL"
export const USER_CHANGE_PASSWORD_FAILED = "USER_CHANGE_PASSWORD_FAILED"

export const USER_LOGOUT_REQUESTED = "USER_LOGOUT_REQUESTED"
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS"
export const USER_LOGOUT_FAILED = "USER_LOGOUT_FAILED"

export const GET_TOKEN_PROFILE_REQUESTED = "GET_TOKEN_PROFILE_REQUESTED"
export const GET_TOKEN_PROFILE_SUCCESS = "GET_TOKEN_PROFILE_SUCCESS"
export const GET_TOKEN_PROFILE_FAILED = "GET_TOKEN_PROFILE_FAILED"

export const SET_AUTH_ERROR = "SET_AUTH_ERROR"
export const TOGGLE_AUTH_MODAL = "TOGGLE_AUTH_MODAL"
export const UNTOGGLE_AUTH_MODAL = "UNTOGGLE_AUTH_MODAL"

export const SIGN_IN_FACEBOOOK_REQUEST = "SIGN_IN_FACEBOOOK_REQUEST"
export const SIGN_IN_FACEBOOOK_SUCCESS = "SIGN_IN_FACEBOOOK_SUCCESS"
export const SIGN_IN_FACEBOOOK_FAILED = "SIGN_IN_FACEBOOOK_FAILED"

export const SIGN_UP_FACEBOOOK_REQUEST = "SIGN_UP_FACEBOOOK_REQUEST"
export const SIGN_UP_FACEBOOOK_SUCCESS = "SIGN_UP_FACEBOOOK_SUCCESS"
export const SIGN_UP_FACEBOOOK_FAILED = "SIGN_UP_FACEBOOOK_FAILED"

export const SIGN_IN_GOOGLE_REQUEST = "SIGN_IN_GOOGLE_REQUEST"
export const SIGN_IN_GOOGLE_SUCCESS = "SIGN_IN_GOOGLE_SUCCESS"
export const SIGN_IN_GOOGLE_FAILED = "SIGN_IN_GOOGLE_FAILED"

export const SIGN_UP_GOOGLE_REQUEST = "SIGN_UP_GOOGLE_REQUEST"
export const SIGN_UP_GOOGLE_SUCCESS = "SIGN_UP_GOOGLE_SUCCESS"
export const SIGN_UP_GOOGLE_FAILED = "SIGN_UP_GOOGLE_FAILED"

export const LOGIN_WALLET_ADDRESS_REQUESTED = "LOGIN_WALLET_ADDRESS_REQUESTED"
export const LOGIN_WALLET_ADDRESS_SUCCESSFUL = "LOGIN_WALLET_ADDRESS_SUCCESSFUL"
export const LOGIN_WALLET_ADDRESS_FAILED = "LOGIN_WALLET_ADDRESS_FAILED"
